//质量板块
import { ItemAttachment, Relationship, PageInfo } from "./commonModules";

import QualityPage from "@/views/model/quality/qualityPage.vue";
import QualityRelationItem from "@/views/model/quality/qualityRelationItem.vue"; //质量-问题对象
import QualityWorkflow from "@/views/model/quality/qualityWorkflow.vue"; //质量-工作流
import QualityRelevance from "@/views/model/quality/qualityRelevance.vue"; //质量-关联相同表单
import QualityHistory from "@/views/model/quality/qualityHistory.vue"; //质量-历史记录

export const Quality = {
  path: "/qualityPage",
  component: QualityPage,
  children: [
    {
      path: "/qualityTitleBlock",
      component: PageInfo,
    },
    {
      path: "/qualityWorkflow",
      name: "qualityWorkflow",
      component: QualityWorkflow,
      // component:() => import('../views/model/quality/qualityWorkflow.vue')
    },
    {
      path: "/qualityRelationItem",
      component: QualityRelationItem,
    },
    {
      path: "/qualityRelevance",
      component: QualityRelevance,
    },
    {
      path: "/qualityAttachment",
      name: "qualityAttachment",
      component: ItemAttachment,
    },
    {
      path: "/qualityRelationship",
      // name: 'qualityRelationship',
      component: Relationship,
    },
    {
      path: "/qualityHistory",
      // name: 'qualityRelationship',
      component: QualityHistory,
    },
  ],
};
